









import { Redirection } from '@empathy/search-types';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { EVENTS } from '../../../bus/events.const';

@Component
export default class RedirectionSuggestion extends Vue {
  @Prop({ required: true })
  suggestion: Redirection;

  @Prop()
  selected: boolean;

  @Prop({ default: EVENTS.RedirectionClicked })
  event: string;

  selectRedirection() {
    this.$x.emit(this.event, this.suggestion);
  }
}
